import React from "react";
import dayjs from "dayjs";
import Icon from "@mdi/react";
import { mdiChevronLeft, mdiChevronRight } from "@mdi/js";

interface Props {
  year: number;
  onYearChange: (year: number) => void;
  month: number | null;
  onMonthChange: (month: number | null) => void;
}

export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export default function MonthGrid({ year, onYearChange, month, onMonthChange }: Props) {
  const today = dayjs();
  const isPast = (index: number) => year < today.year() || (year === today.year() && index < today.month());

  return (
    <>
      <div className="v2-months__nav">
        <button
          type="button"
          aria-label="Previous year"
          disabled={year <= today.year()}
          onClick={() => onYearChange(year - 1)}
        >
          <Icon path={mdiChevronLeft} size="24px" />
        </button>
        <span>{year}</span>
        <button type="button" aria-label="Next year" onClick={() => onYearChange(year + 1)}>
          <Icon path={mdiChevronRight} size="24px" />
        </button>
      </div>

      <div className="v2-months__grid">
        {MONTHS.map((label, index) => (
          <button
            key={label}
            type="button"
            disabled={isPast(index)}
            className={`v2-months__cell ${month === index ? "is-active" : ""}`}
            onClick={() => onMonthChange(month === index ? null : index)}
          >
            {label}
          </button>
        ))}
      </div>
    </>
  );
}
